import { render, staticRenderFns } from "./interest-count.vue?vue&type=template&id=789c79e2&scoped=true&"
var script = {}
import style0 from "./interest-count.vue?vue&type=style&index=0&id=789c79e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c79e2",
  null
  
)

export default component.exports